"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 23. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ReleasePartActionResultConverter_1 = require("./ReleasePartActionResultConverter");
/**
 * Default implementation of release item converter.
 *
 * @author Radek Beran
 */


var ReleasePartActionResultConverterImpl =
/*#__PURE__*/
function (_ReleasePartActionRes) {
  _inherits(ReleasePartActionResultConverterImpl, _ReleasePartActionRes);

  function ReleasePartActionResultConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ReleasePartActionResultConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePartActionResultConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleasePartActionResultConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      throw new Error("Not implemented (not needed).");
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, {
        success: source.success,
        categoryId: source.categoryId,
        errorCode: source.errorCode,
        errorSubcode: source.errorSubcode,
        conflictingUser: utils_1.Utils.isObject(source.conflictingUser) ? this.userInfoConverter.toDocument(source.conflictingUser, conversions) : null
      });
      return document;
    }
  }]);

  return ReleasePartActionResultConverterImpl;
}(ReleasePartActionResultConverter_1.ReleasePartActionResultConverter);

ReleasePartActionResultConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ReleasePartActionResultConverterImpl);
exports.ReleasePartActionResultConverterImpl = ReleasePartActionResultConverterImpl;